import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), {
    ref: "reference",
    onMouseover: _ctx.onOpenTooltip,
    onMouseleave: _ctx.close
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default"),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(_Transition, { name: "tooltip" }, {
          default: _withCtx(() => [
            (_ctx.isVisible)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bs-tooltip",
                  ref: "tooltip",
                  style: _normalizeStyle({ position: _ctx.strategy, left: `${_ctx.x}px`, top: `${_ctx.y}px` })
                }, _toDisplayString(_ctx.tooltipContent), 5))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]))
    ]),
    _: 3
  }, 40, ["onMouseover", "onMouseleave"]))
}